import { Component, EventEmitter, Input, Output } from '@angular/core';

@Component({
  selector: 'app-property-share-sms',
  templateUrl: './share-sms.component.html',
  styleUrls: [
    '../share-emails/share-emails.component.scss',
    './share-sms.component.scss',
  ],
})
export class PropertyShareSMSComponent {
  @Input({ required: true }) propertyId: string = '';
  @Output() handleClose = new EventEmitter<void>();
}
